export default __webpack_public_path__ + "static/media/shadow_blue.bd61a55e.png";